import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.css';

const InlineAutocomplete = ({ inputValue, isActive, highlightedLabel }) => {
  if (!isActive) {
    return null;
  }

  const suggestionText = `${inputValue}${highlightedLabel.slice(
    inputValue.length
  )}`;

  return (
    <div
      className={cn(styles.inlineAutocomplete, styles.textInputPadding)}
      aria-hidden
    >
      {suggestionText}
    </div>
  );
};

InlineAutocomplete.propTypes = {
  inputValue: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  highlightedLabel: PropTypes.string,
};

export default InlineAutocomplete;
